import { render } from "./TrafficGroupRateChangeForm.vue?vue&type=template&id=49968df6&ts=true"
import script from "./TrafficGroupRateChangeForm.vue?vue&type=script&lang=ts"
export * from "./TrafficGroupRateChangeForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__